export const baseSteps = [
    {
        type: 'question',
        questionName: 'existingCoverage',
        questionText: 'Do you have {ProgramName} coverage?',
        options: [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ]
    },
    {
        type: 'question',
        questionName: 'ownHome',
        questionText: 'Do you own your home?',
        options: [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ]
    },
    {
        type: 'question',
        questionName: 'dress',
        questionText: 'Was the dress gold and white or blue and black?',
        options: [
            { display: 'Gold/White', value: 'yes' },
            { display: 'Blue/Black', value: 'no' }
        ]
    },
    {
        type: 'question',
        questionName: 'pizza',
        questionText: 'Does Pineapple belong on pizza?',
        options: [
            { display: 'Yes', value: 'yes' },
            { display: 'Yes', value: 'yassss' }
        ]
    },
    {
        type: 'categorySelect'
    },
    {
        type: 'co-op',
        question: 'Are you a member of a co-op?',
        options: [
            // POPULATE THIS DYNAMICALLY, PERHAPS IN COMPONENT.
        ]
    }
    // APPEND THIS LIST WITH CATEGORY STEPS AFTER LOADING THEM.
];
